export const CHANNEL = {
  SEM: 'SEM',
  FACEBOOK: 'facebook'
}
